import graphql from 'babel-plugin-relay/macro'
import {useMutation} from 'react-relay'


const mutation = graphql`
  mutation useUploadUserAssetMutation($file: File!) {
    uploadUserAsset(file: $file) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ... on UploadUserAssetSuccess {
        url
      }
    }
  }
`





export const useUploadUserAsset = () => {
  const [commit, submitting] = useMutation(mutation)
  



  const execute = (config) => {
    return commit({
      // allow components to override default handlers
      ...config
    })
  }
  return [execute, submitting] 
}
